import paymentService from "../../service/payment.service";
import freightFinancialService from "../../service/freight-financial.service";
import {
  buildFreightBoletoEmailAttachmentRefs,
} from "../../util/freight/freight-document-utils";
import {
  extractShipperFinancialContacts,
  logBoletoEmail,
  logBoletoEmailError,
  BOLETO_EMAIL_NO_RECIPIENT_MESSAGE,
} from "../../util/freight/freight-invoice-email-utils";

export async function sendFreightInvoiceBoletoFromPanel({
  freightId,
  freightData,
  record,
  shipperData,
  user,
  boletoFile,
  boletoAttachment,
  financialInstallments,
  installmentNumber,
  resolveUploadedBoletoAttachment,
}) {
  logBoletoEmail("Iniciando envio", { freightId });

  logBoletoEmail("Buscando destinatário", { freightId });
  const contacts = extractShipperFinancialContacts(shipperData);

  if (!contacts.length) {
    logBoletoEmailError(
      "Erro ao enviar boleto",
      new Error("Destinatário ausente"),
      { freightId, stage: "destinatario" },
    );
    return {
      success: false,
      message: BOLETO_EMAIL_NO_RECIPIENT_MESSAGE,
    };
  }

  logBoletoEmail("Destinatário encontrado", {
    freightId,
    recipientCount: contacts.length,
  });

  let resolvedAttachment = boletoAttachment;
  const resolvedInstallmentNumber =
    installmentNumber ?? record?.installmentNumber ?? 1;

  if (boletoFile && freightId) {
    logBoletoEmail("Buscando boleto", {
      freightId,
      source: "upload-local",
    });

    const uploadResult = await freightFinancialService.uploadBoleto(
      freightId,
      boletoFile,
      {
        installmentNumber: resolvedInstallmentNumber,
        financialInstallments,
      },
    );
    resolvedAttachment = resolveUploadedBoletoAttachment(
      uploadResult,
      boletoFile,
    );
    logBoletoEmail("Boleto encontrado", {
      freightId,
      hasAttachment: Boolean(resolvedAttachment),
    });
  } else {
    logBoletoEmail("Buscando boleto", {
      freightId,
      source: "existente",
      hasAttachment: Boolean(resolvedAttachment),
    });
  }

  const attachmentRefs = buildFreightBoletoEmailAttachmentRefs(
    freightData,
    resolvedAttachment,
  );

  if (!attachmentRefs.length) {
    logBoletoEmailError(
      "Erro ao enviar boleto",
      new Error("Boleto indisponível para anexo"),
      { freightId, stage: "validacao-boleto" },
    );
    return {
      success: false,
      message:
        "Não foi possível localizar o boleto para anexar ao e-mail. Salve o anexo e tente novamente.",
    };
  }

  logBoletoEmail("Chamando serviço de envio", {
    freightId,
    attachmentCount: attachmentRefs.length,
    recipientCount: contacts.length,
  });

  try {
    const result = await paymentService.sendFreightControlBoletoEmail({
      freightId,
      freightData,
      record,
      shipperData,
      user,
      boletoAttachment: resolvedAttachment,
    });

    if (result?.success) {
      logBoletoEmail("Envio concluído com sucesso", { freightId });
    } else {
      logBoletoEmailError(
        "Erro ao enviar boleto",
        new Error(result?.message || "Falha no envio"),
        { freightId, stage: "servico-email" },
      );
    }

    return result;
  } catch (error) {
    logBoletoEmailError("Erro ao enviar boleto", error, {
      freightId,
      stage: "servico-email",
    });
    throw error;
  }
}

export async function sendFreightInvoiceChargeFromPanel({
  freightId,
  freightData,
  record,
  shipperData,
  user,
}) {
  return paymentService.sendFreightControlChargeEmail({
    freightId,
    freightData,
    record,
    shipperData,
    user,
  });
}
